"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const WEEK_DAY_MAP_1 = __importDefault(require("../../../../constants/date/WEEK_DAY_MAP"));
/**
 * Returns the corresponding number for the day
 * @param {string} day eg. Monday
 * @returns {number} eg. 1
 */
const getDayNumber = (day) => {
    return WEEK_DAY_MAP_1.default[day.toUpperCase()];
};
exports.default = getDayNumber;
